import { init, replayIntegration, browserTracingIntegration } from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

// Only run Sentry in production. In dev it shipped a transaction + every
// console.log on each navigation, which flooded the project quota and returned
// 429 (Too Many Requests). Errors still surface in the dev console.
if (import.meta.env.PROD) {
  init({
    dsn: "https://61815e6268f9e58570cb775bb6e968fe@o4509742709080064.ingest.de.sentry.io/4509742717206608",
    // Sample a fraction of transactions instead of every one to stay under quota.
    tracesSampleRate: 0.1,
    // Don't forward console.log/info/etc. as Sentry logs — that was the main
    // source of envelope spam (every [nav]/[loader]/[fs] line became an event).
    enableLogs: false,

    integrations: [browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches
    }), replayIntegration({
        maskAllText: true,
        blockAllMedia: true
    })],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});